var _ = require("../uam/fields.module.js")(module.exports, {
    namespace: "uri",
    title: "URI",
    description: "Validates that the value is a proper URI/URL or path.",
    type: "field",
    use: {
        namespace: "ua.text"
    },
    fields: {
        protocols: {
            title: "Allowed Protocols",
            type: "list",
            of: "string",
            description: "If provided, only these protocols will be allowed. Case insesitive. For example: ['http', 'https', 'file'].",
        },
        url: {
            title: "Must be a URL",
            type: "toggle",
            description: "Must be a valid URL.",
            default: false
        },
        securedUrl: {
            title: "Secured URL",
            type: "toggle",
            description: "Must be a valid secured URL (https://).",
            default: false
        },
        filePath: {
            title: "File Path",
            type: "toggle",
            description: "Must be a valid file path.",
            default: false
        }
    },
    tests: {
        validUrl: {
            must: true,
            run: function () {
                return validate({ title: "Asset" }, "https://example.com");
            }
        },
        validPath: {
            must: true,
            run: function () {
                return validate({}, "../images/logo.png");
            }
        },
        invalid: {
            throw: "fields.uri.invalid",
            run: function () {
                return validate({}, "bad uri\\slash\\thing");
            }
        }
    },
    errors: {
        invalid: {
            title: "Invalid URI",
            description: "Must be a valid URL or relative path.",
            template: "Invalid URI: '${value}'"
        },
        notUrl: {
            title: "Not a URL",
            description: "The provided value is not a valid URL.",
            template: "The value '${value}' is not a valid URL. Must be https:// or http://."
        },
        insecuredUrl: {
            title: "Insecured URL",
            description: "The provided value is not a secured URL.",
            template: "The value '${value}' is not a secured URL. Must be https://."
        },
        notAllowedProtocol: {
            title: "Protocol Not Allowed",
            description: "The provided URI uses a protocol that is not allowed.",
            template: "The protocol '${protocol}' is not allowed. Allowed protocols are: ${allowedProtocols}."
        },
        notaFilePath: {
            title: "Not a File Path",
            description: "The provided URI is not a valid file path.",
            template: "The value '${value}' is not a valid file path."
        }
    }
});

/**
 * Validates the value as a URI (either URL or relative path)
 * @param {*} spec The field specification (not used much here)
 * @param {*} value The value to check
 */
function validate(spec, value) {
    if (typeof value !== "string") {
        _.errors.invalid.throw({ value: value });
    }

    // Accepts: http(s), file, @!, ../, ./, /, or full domain
    var uriPattern = /^(https?:\/\/|file:\/\/|@!\/|\.{1,2}\/|\/)[\w\-./@!]+$/;

    if (!uriPattern.test(value)) {
        _.errors.invalid.throw({ value: value });
    }
    
    // if protocols are specified, check if the URI starts with one of them
    if (spec.protocols && spec.protocols.length > 0) {
        //note the user can provide mailto or ftp or anything. Mailto does not have // at he start but all others do and we need to support ANY known or unknown protocol.
        var allowedProtocols = spec.protocols.map(p => p.toLowerCase());
        
        //is mailto included in the allowed protocols?
        if (allowedProtocols.includes("mailto") && value.toLowerCase().startsWith("mailto:")) {
            //if mailto is allowed and the value starts with mailto: then we are good
            return;
        } else {
            //check if the URI starts with any of the allowed protocols
            var protocolMatch = value.match(/^([a-zA-Z][a-zA-Z0-9+\-.]*:\/{1,3}|\.{1,2}\/|\/)/);
            if (protocolMatch) {
                var protocol = protocolMatch[0].toLowerCase();
                if (!allowedProtocols.includes(protocol.replace(/:\/\//, ''))) {
                    _.errors.notAllowedProtocol.throw({
                        protocol: protocol,
                        allowedProtocols: allowedProtocols.join(", ")
                    });
                }
            }
        }
    }

    //if you have a url
    if ("url" in spec && spec.url) {
        // If the spec requires it to be a URL, check if it starts with http:// or https://
        if (spec.url && !value.startsWith("http://") && !value.startsWith("https://")) {
            _.errors.notUrl.throw({ value: value });
        }
    }

    //if you have a secured url
    if ("securedUrl" in spec && spec.securedUrl) {
        // If the spec requires it to be a secured URL, check if it starts with https://
        if (spec.securedUrl && !value.startsWith("https://")) {
            _.errors.insecuredUrl.throw({ value: value });
        }
    }

    //if you have a file path
    if ("filePath" in spec && spec.filePath) {
        // Check if the value is a valid file path
        // A simple check for file paths: must not contain any invalid characters and can start with ../, ./, or /
        var filePathPattern = /^(?:\.{1,2}\/|\/)[\w\-./@!]+$/;
        if (!filePathPattern.test(value)) {
            _.errors.notaFilePath.throw({ value: value });
        }
    }

}

module.exports.validate = validate;
